export const POST_ASSIGN_LABEL = {
  INHERENT_RISK_SET_TO: 'Inherent Risk set to:',
  NEXT_STEP: 'Next step:',
  SELECT_PROJECTS_TITLE: 'Select projects to assess',
  SELECT_PROJECTS_SUBTITLE: 'Select the required projects for assessments',
  ADD_ASSESSMENTS: 'Add assessments',
  ERROR_NO_PROJECT_SELECTED: 'Please select at least one project',
  ERROR_CREATE_FAILED: 'Failed to create assessments',
} as const
